var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckCircleGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6673 8.50016C14.6673 12.1821 11.6825 15.1668 8.00065 15.1668C4.31875 15.1668 1.33398 12.1821 1.33398 8.50016C1.33398 4.81826 4.31875 1.8335 8.00065 1.8335C11.6825 1.8335 14.6673 4.81826 14.6673 8.50016ZM10.6875 6.47994C10.8828 6.6752 10.8828 6.99179 10.6875 7.18705L7.3542 10.5204C7.15894 10.7156 6.84236 10.7156 6.6471 10.5204L5.31376 9.18705C5.1185 8.99179 5.1185 8.6752 5.31376 8.47994C5.50903 8.28468 5.82561 8.28468 6.02087 8.47994L7.00065 9.45972L8.49054 7.96983L9.98043 6.47994C10.1757 6.28468 10.4923 6.28468 10.6875 6.47994Z",
    fill: "#06AD00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleGreen);
export default __webpack_public_path__ + "static/media/checkCircleGreen.cf76646d054c4c7d52cc501399685bf9.svg";
export { ForwardRef as ReactComponent };